(function ($) {
    $(document).ready(function () {
        menuclick();
        fixed_menu();


        $('body .header-menu .search').click(function () {
            // console.log("test");
            $(this).parent().addClass('search-active');
            $('body .header-menu .main-nav .search-outer').addClass('expanded');
            if ($('body .header-menu .main-nav .search-outer').hasClass('expanded')) {
                $('body .header-menu .header-inner .main-nav .full-nav').css({'opacity': '0'});
                $('body .header-menu .header-inner .main-nav .search').css({'opacity': '0'});
            }
        });
        $('body .header-menu .main-nav .search-outer .cross-outer').click(function () {
            if ($('body .header-menu .main-nav .search-outer').hasClass('expanded')) {
                $('body .header-menu .header-inner .main-nav .full-nav').css({'opacity': '1'});
                $('body .header-menu .header-inner .main-nav .search').css({'opacity': '1'});
                $('body .header-menu .main-nav .search-outer').removeClass('expanded');
                $('body .header-menu .main-menu').removeClass('search-active');
            }
        });


    });

    $(window).on("load resize", function () {
        var win_height = $(window).height() - 130;
        $('body.ua-mobile .header-menu .header-inner .main-nav .main-menu').css({
            'height': win_height
        })
    });


    $(window).on("load", function () {
        $(".main-menu > ul > li").each(function () {
            var link_url = $(this).children().attr("href");
            if(link_url.indexOf("portfolio")>0){
                $(this).addClass("portfolio-filter-nav");
            }
        });
        $(".footer .menu .container > ul > li").each(function () {
            var link_url = $(this).children("a").attr("href");
            if(link_url.indexOf("portfolio")>0){
                $(this).addClass("portfolio-filter-nav");
            }
        });
        $(document).on("click",".portfolio-filter-nav > ul > li > a",function (e) {
            // var scroll = $(window).scrollTop();
            // var url = window.location.pathname;
            // if(url==="/portfolio/"){
                // e.preventDefault();
                // var id = $(this).text();
                //
                // $("#portfolio-industry .sub-menu.hidden-filter li").each(function () {
                //     var filter_text = $(this).text();
                //     if(filter_text===id){
                //         $(this).trigger("click");
                //     }
                // });
                // var target =$(".portfolio-filter");
                // if(target.length>0){
                //     var offsetTop = target.offset().top;
                //     if(scroll > offsetTop){
                //         var navHeight = $('.header-menu').height();
                //     }
                //     else{
                //         var navHeight = 0;
                //     }
                //     $('html, body').animate({
                //         scrollTop: $(".portfolio-filter").offset().top - navHeight - 20
                //     }, 500);
                // }
            // }
        });
        toggle_Effect();
        show_menu();
        iPad();
        var winwidth = $(window).width();
        if (winwidth > 767) {
            $(".sticky-nav ul").addClass("active");
        }

        $('header').css({"opacity": 1});
    });

    function iPad() {
        $('.ua-mobile header .header-inner .main-nav .main-menu > ul > li > a ').click(function (e) {
            e.preventDefault();
        });
    }

    $('header.header-inner .main-nav .mobile-nav .hamburger.active').click(function (e) {
        $('header .drop').not($(this).siblings('.sub-menu')).slideUp();
        $(this).siblings('.sub-menu').stop(true, true).slideToggle();
    });

    function toggle_Effect() {
        $('header .mobile-nav').click(function (e) {
            e.stopPropagation();
            $('header').toggleClass('menutoogle');
            $("header .main-menu").stop(true, true).slideToggle();
            $('header .sub-menu').slideUp();
            $('header .header-inner .main-nav .main-menu > ul > li').removeClass('menu-active');
        });
    }


    function show_menu() {
        $('header .header-inner .main-nav .main-menu > ul > li > a ').click(function (e) {
            var win_width = $(window).width();
            if (win_width <= 767) {
                e.stopPropagation();
                e.preventDefault();
                $('header .sub-menu').not($(this).siblings('.sub-menu')).slideUp();
                $(this).siblings('.sub-menu').stop(true, true).slideToggle();
                $(this).parent().toggleClass('menu-active');
                $(this).parent().siblings('li').removeClass('menu-active');
            }
        });
    }

    $(window).resize(function () {
        menuclick();
        fixed_menu();

        var window_width = $(window).width();
        if (window_width > 767) {
            $('body').removeClass('overflow');
            $("header .main-menu").removeAttr('style');
        } else {
            $("header .main-menu").stop(true, true).slideUp();
        }
        $('header .sub-menu').slideUp();
        $('header .header-inner .main-nav .main-menu > ul > li').removeClass('menu-active');
        $('header').removeClass('menutoogle');
        $('body').removeClass('overflow');
    });

    function menuclick() {
        var window_width = $(window).width();
        // $('body .header-menu .header-inner .main-nav.burger-menu .search-outer').css({'bottom': '0'});
        if ($('body .header-menu .main-nav.burger-menu > ul').hasClass('mobile')) {
            $('body .header-menu .main-nav.burger-menu > ul').removeClass('mobile');
            $('body .header-menu .main-nav.burger-menu > ul').addClass('full-nav');
        }
        if ($('body .header-menu .header-inner .main-nav ul.drop').hasClass('drop')) {
            $('body .header-menu .header-inner .main-nav ul.drop').removeClass('drop');
            $('body .header-menu .header-inner .main-nav ul li ul').addClass('sub-menu');
        }
        $('body .header-menu .main-nav.burger-menu .mobile-nav .hamburger').removeClass('active');
        $('body .header-menu .main-nav.burger-menu > ul').removeClass('subnav');
        $('body .header-menu .header-inner .main-nav.burger-menu .search-outer').removeClass('active');
        if (window_width <= 767) {
            $('body .header-menu .main-nav').addClass('burger-menu');
            if ($('body .header-menu .main-nav.burger-menu > ul').hasClass('full-nav')) {
                $('body .header-menu .main-nav.burger-menu > ul').removeClass('full-nav');
                $('body .header-menu .main-nav.burger-menu > ul').addClass('mobile');
            }

            $('body .header-menu .main-nav.burger-menu .mobile-nav .hamburger').unbind().click(function (e) {
                // $('body .header-menu .header-inner .main-nav.burger-menu .search-outer').css({'bottom': '-282px'});
                e.preventDefault();
                $("header").addClass("off-canvas");
                $('body .header-menu .main-nav.burger-menu > ul').toggleClass('subnav');
                $('body .header-menu .main-nav.burger-menu .mobile-nav .hamburger').toggleClass('active');
                $('body .header-menu .header-inner .main-nav.burger-menu .search-outer').toggleClass('active');
                $('body').toggleClass('overflow');
                if ($('body .header-menu .header-inner .main-nav .mobile li').hasClass('active')) {
                    $('body .header-menu .header-inner .main-nav .mobile li').removeClass('active');
                }
            });

            ///////submenu////
            if ($('body .header-menu .header-inner .main-nav ul.sub-menu').hasClass('sub-menu')) {
                // $('body .header-menu .header-inner .main-nav ul.sub-menu').removeClass('sub-menu');
                // $('body .header-menu .header-inner .main-nav ul li ul').addClass('drop');
            }
            $('body .header-menu .header-inner .main-nav.burger-menu .mobile li').unbind().click(function (e) {
                // e.preventDefault();
                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    // $('body .header-menu .header-inner .main-nav.burger-menu .search-outer').css({'bottom': '-282px'});
                } else {
                    $('body .header-menu .header-inner .main-nav.burger-menu .mobile li').removeClass('active');
                    $(this).toggleClass('active');
                    // $('body .header-menu .header-inner .main-nav.burger-menu .search-outer').css({'bottom': '-460px'});
                }

            });
        } else {
            $('body .header-menu .main-nav').removeClass('burger-menu');
        }
    }

    function fixed_menu() {

        var scroll = $(document).scrollTop(),
            bannerHeight = ($('header').height() + parseInt($('header').css('top'))) / 2,
            scrolled = $(document).scrollTop(),
            isNavSticky = true;
        $(window).on('scroll load', function () {
            var scrolled = jQuery(document).scrollTop();
            if ((scrolled > scroll)) {
                if (scrolled >= bannerHeight && isNavSticky === true) {
                    $(".header-inner").addClass("fixed");
                    isNavSticky = false;
                }
                $(".header-inner").removeClass("off-canvas");
            } else if ((scrolled < scroll)) {
                if (scrolled > bannerHeight && isNavSticky === false) {
                    $(".header-inner.fixed").addClass("off-canvas");
                    isNavSticky = true;
                } else if (scrolled < bannerHeight && isNavSticky === true) {
                    $(".header-inner").removeClass("off-canvas");
                    $(".header-inner").removeClass("fixed");
                    isNavSticky = false;
                }
                isNavSticky = true;
            }
            scroll = $(document).scrollTop();
            var winwidth = $(window).width();
            if (winwidth > 767) {
                if ($("body .header-menu .header-inner").hasClass("fixed")) {
                    $("body .header-menu .header-inner .main-nav .logo").removeClass("wow fadeInUp").removeAttr("data-wow-delay style");
                    $("body .header-menu .header-inner .main-nav .main-menu > ul > li").removeClass("wow fadeInUp").removeAttr("data-wow-delay style");
                    $("body .header-menu .header-inner .search").removeClass("wow fadeInUp").removeAttr("data-wow-delay style");
                }
            }

        });
    }

})(jQuery);